export default function FooterSection() {
  return (
    <footer
      className="py-10"
      style={{ backgroundColor: "#1e1e1f", borderTop: "1px solid rgba(255,255,255,0.06)" }}
      data-testid="footer-section"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-12 text-center">
        <p
          className="text-xs"
          style={{ color: "#b0b0b5", fontFamily: "'Inter', sans-serif" }}
        >
          The Soft Reset. All rights reserved. | Secure payments by Stripe.
        </p>
      </div>
    </footer>
  );
}
